import React, { Component } from 'react';
import jQuery from 'jquery';
import FetchCall from '../../../../API/FetchCall';
import {  updateInsights, commonAPI } from '../../../../API/FetchCall';
const $ = require('jquery')

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';


class UploadArticle extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        this.state = {
            logged: localStorage.getItem("authentication"),
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            insight_id: 0,
            insight_title: '',
            insight_desc: '',
            banner_image: '',
            banner_new: '',
            gallery_image: '',
            article_images: '',
            show_upload: false,
            articleuploaded: false,
            gallery_new: '',
            insight_content: '',
            insight_author: '',
            about_author: '',
            related_vertical:'',
            social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" },
            { id: "in", name: 'Instagram', link: "" }, { id: "tw", name: 'Twitter', link: "" }],
            imageList: [],
            suggestions: [],
            location: [],
            locationList: [],
            btnDisable: false,
            editorState: EditorState.createEmpty()
        }

         this.getLocation();

    }


    componentDidMount() {

        var THIS = this;

    }

      handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }


  getLocation = () => {
    let req = JSON.stringify({
      url: 'location_list'
    });
    commonAPI(req).then(res => {
      if (res.status === 1) {
        this.setState({
          locationList: res.list
        })
      }
    })
  }


 handleEditorChange(value, editor) {
    console.log(value);
    this.setState({
      insight_content: value
    });
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheck = (e) => {
    this.setState((prevState) => ({
      show_upload: !prevState.show_upload,
    }));
  };


    handleSubmit = (e) => {

      const { user_type, login_id } = this.state.auth_data;  

      let insert = {
        insight_id: this.state.insight_id,
        insight_title: this.state.insight_title,
        insight_desc: this.state.insight_desc,
        related_vertical:this.state.related_vertical,
        location: this.state.location,
        insight_content: this.state.insight_content,
        insight_author:login_id,
        user_id:login_id,
        status:0,
        banner_new: this.state.banner_new,
        gallery_new: this.state.gallery_new
      }
      updateInsights(insert).then((response) => {
        this.setState({
          btnDisable: false
        })
        if (response.status == 1) {
           alert("Insight is added");
        } else {
           alert("Issue in adding insight");
        }
      });
 

  }


  handleFile = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({
      [propName]: files
    });
  };

    onChangeEditor = (editorState) => {
    //const contentState = editorState.getCurrentContent();
    //console.log("plain text", editorState.getCurrentContent().getPlainText());

    const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

    console.log("html", contentState);
    //const raw = convertToRaw(contentState);
    this.setState({
      consigne:editorState,
      insight_content:contentState
    });
  }


    componentDidUpdate() {
        //window.jQuery('.selectpicker').selectpicker('refresh');
    }

    render() {

        const { insight_content, editorState, consigne} = this.state;

        return (
            <React.Fragment>
                <div class="box-shadow-custom">


                  <div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Title <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='insight_title' className='form-control' type='text' value={this.state.insight_title}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Description <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <textarea name='insight_desc' className='form-control' rows={3} value={this.state.insight_desc}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      

                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Blog related to <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select class="form-control" name="related_vertical" value={this.state.related_vertical}  onChange={this.handleChange} >
                            
                              <option value="">Select</option>
                              <option value="tuitionblogs">Tuition Blogs</option>
                              <option value="schoolblogs">School Blogs</option>
                              <option value="preschoolblogs">Preschool Blogs</option>
                              <option value="danceblogs">Dance Blogs</option>
                              <option value="sportsblogs">Sports Blogs</option>
                              <option value="musicblogs">Music Blogs</option>
                              <option value="artblogs">Art Blogs</option>
                              <option value="hobbiesblogs">Hobbies Blogs</option>

                          </select>
                        </div>
                      </div>


                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Blog Banner Image <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input
                            type="file"
                            name="gallery_new"
                            onChange={this.handleFile}
                            className="form-control mar-btm"
                            accept="image/x-png,image/gif,image/jpeg"
                          />

                        
                        </div>
                        
                      </div>
                       
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label> Content <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">


                           <Editor
                            handlePastedText={() => false}
                            value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                            editorState={consigne}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            onEditorStateChange={this.onChangeEditor.bind(this)}
                            toolbar={{
                              image: {
                              previewImage: true,
                              uploadCallback: uploadImageCallBack,
                              alt: { present: true, mandatory: false },
                              },
                            }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Location <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select className='form-control selectpicker' name='location' value={this.state.location}
                            onChange={this.handleSelect} multiple data-live-search="true"
                            data-actions-box="true">
                            {this.state.locationList.map((item, i) => {
                              return (
                                <option value={item.id}>{item.location}</option>
                              )
                            })}
                          </select>
                           

                        </div>
                      </div>
                     
                      <div className="row mb-4 text-right">
                        <button type='submit' id="btnSubmit"
                          className="btn btn-primary btn-sm" onClick={this.handleSubmit} disabled={this.state.btnDisable} style={{ display: "block", margin: "auto" }}>
                          Submit
                        </button>
                      </div>
                      

                     
                    </div>                          


                </div>
            </React.Fragment>
        )
    }
}
function uploadImageCallBack(file) {
  return new Promise(
    (resolve, reject) => {
      const reader = new window.FileReader();
      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
      xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
      xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
      const data = new FormData(); // eslint-disable-line no-undef
      data.append('image', file);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        const response = JSON.parse(xhr.responseText);
        resolve(response);
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    },
  );
}

export default UploadArticle;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/articles/uploadyourarticle.jsx